<div class="fixed inset-0 z-50">
  <button type="button"
          tabindex="-1"
          aria-hidden="true"
          class="auth-drawer-backdrop absolute inset-0 w-full h-full p-0! border-0 cursor-default"
          (click)="closed.emit()">
  </button>
  <div role="dialog"
       aria-modal="true"
       aria-labelledby="auth-drawer-title"
       cdkTrapFocus
       [cdkTrapFocusAutoCapture]="true"
       class="auth-drawer-panel absolute top-0 right-0 bottom-0 w-full max-w-[460px] box-border flex flex-col gap-7! overflow-y-auto bg-white pt-6! px-6! sm:px-10! pb-10!">
    <div class="flex justify-end">
      <button type="button" class="auth-icon-btn w-11 h-11 -mr-2.5" [attr.aria-label]="'close' | translate" (click)="closed.emit()">
        <i-tabler name="x" class="icon-20 d-flex" />
      </button>
    </div>

    <div class="flex flex-col gap-2.5!">
      <h2 id="auth-drawer-title" class="auth-title">{{ heading | translate }}</h2>
      @if (description) {
        <p class="auth-subtitle leading-[1.6]!">{{ description | translate }}</p>
      }
    </div>

    <ng-content />
  </div>
</div>
